import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import { useGalleryFilterSearchParams } from "../hooks/useGalleryFilterSearchParams";
import { makeLogger } from "../../utils/o11y/logger";

const logger = makeLogger({
  enabled: true,
  label: "EventPageSearchBar",
  color: "#FF9999",
});

const DEFAULT_TIMEOUT_TO_CHANGE_ANY_FIELD_FILTER_CHANGE = 500;

export default function EventPageSearchBar({ photographerNickName }) {
  const navigate = useNavigate();
  const { country } = useParams();
  const [galleryFilterSearchParams, syncGalleryFilterSearchParam, urlParams] =
    useGalleryFilterSearchParams();
  const isSearchActive = galleryFilterSearchParams.any !== undefined;

  const [anyFieldInputText, setAnyFieldInputText] = useState(
    galleryFilterSearchParams.any,
  );

  useEffect(
    function syncTextboxWithUrl() {
      if (!galleryFilterSearchParams.any) {
        setAnyFieldInputText("");
      }
    },
    [galleryFilterSearchParams.any],
  );

  const [timeoutId, setTimeoutId] = useState();
  const handleAnyFieldInputTextChanged = (e) => {
    const { value } = e.target;
    setAnyFieldInputText(value ?? "");
    if (timeoutId) {
      clearTimeout(timeoutId); // cancel pending redirect
    }
    const id = setTimeout(() => {
      if (!anyFieldInputText) {
        if (photographerNickName && country) {
          navigate(`/${country}/${photographerNickName}`);
        } else {
          navigate(`/customer/events/`);
        }
      } else {
        syncGalleryFilterSearchParam({ any: value });
      }
    }, DEFAULT_TIMEOUT_TO_CHANGE_ANY_FIELD_FILTER_CHANGE);
    setTimeoutId(id);
  };

  const handleClearSearch = () => {
    setAnyFieldInputText("");
    syncGalleryFilterSearchParam({ any: null });
  };

  return (
    <Paper
      component="div"
      sx={{
        width: 500,
        display: "flex",
        alignItems: "center",
        marginTop: "14px",
        marginBottom: "10px",
        paddingLeft: "16px",
        paddingY: "4px",
        boxShadow: "none",
        borderRadius: "24px",
      }}
    >
      <InputBase
        sx={{
          ml: 1,
          flex: 1,
          letterSpacing: "-0.2pt",
          color: "black",
          "& input": {
            padding: "8px 0",
          },
          "& input::placeholder": {
            color: "black",
            opacity: 1,
          },
        }}
        value={anyFieldInputText}
        onChange={handleAnyFieldInputTextChanged}
        placeholder={photographerNickName
          ? "Search Galleries by Name, Event, School"
          : "Search Galleries by Name, Event, School, Photographer"}
      />
      {isSearchActive ? (
        <IconButton
          type="button"
          sx={{ p: "10px" }}
          title="Clear search"
          onClick={handleClearSearch}
        >
          <ClearIcon />
        </IconButton>
      ) : (
        <IconButton type="button" sx={{ p: "10px" }}>
          <SearchIcon />
        </IconButton>
      )}
    </Paper>
  );
}
